import { createSelector } from 'reselect';

import { Selector } from 'react-redux';
import { MultimediaState } from './multimediaTypes';
import { RootState } from '../../../core/redux/model/rootStateModel';
import { MultimediaGetResponse, MultimediaValues } from '../model/multimediaModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

const getRoot = (state: RootState) => state.multimedia;

export const apiMultimediaRequestState = createSelector<[Selector<RootState, MultimediaState>], API_REQUEST_STATE>(
  getRoot,
  (root: MultimediaState) => root.apiMultimediaRequestState,
);

export const apiMultimediaRequestError = createSelector<[Selector<RootState, MultimediaState>], string | null>(
  getRoot,
  (root: MultimediaState) => root.apiMultimediaRequestError,
);

export const apiAllMultimediaRequestState = createSelector<[Selector<RootState, MultimediaState>], API_REQUEST_STATE>(
  getRoot,
  (root: MultimediaState) => root.apiAllMultimediaRequestState,
);

export const apiAllMultimediaRequestError = createSelector<[Selector<RootState, MultimediaState>], string | null>(
  getRoot,
  (root: MultimediaState) => root.apiAllMultimediaRequestError,
);

export const multimedia = createSelector<[Selector<RootState, MultimediaState>], MultimediaGetResponse>(
  getRoot,
  (root: MultimediaState) => root.multimedia,
);

export const allMultimedia = createSelector<[Selector<RootState, MultimediaState>], MultimediaGetResponse[]>(
  getRoot,
  (root: MultimediaState) => root.allMultimedia,
);

export const initialValues = createSelector<[Selector<RootState, MultimediaState>], MultimediaValues>(
  getRoot,
  (root: MultimediaState) => {
    return {
      file: root.multimedia.gcsUrl ?? '',
      name: root.multimedia.name ?? '',
    };
  },
);
